import {LocalDateTime} from '@js-joda/core';
import {v4} from 'uuid';

import {cdmMw} from '../api';

export default {
    api: cdmMw,
    url: (params) => 'api/symbol-adv',
    useCache: false,
    defaultValue: {
        more: false,
        rowData: [],
        timestamp: LocalDateTime.now()
    },
    parseResponse: (data) => ({
        more: data?.meta?.more ?? false,
        rowData: (data?.data ?? []).map((item) => ({
            ...item,
            uuid: v4()
        })),
        timestamp: LocalDateTime.now()
    }),
    resetDataOnRequest: false
};
